export const ApiDef_LogTemplate = {
    _v1: {}
};
//# sourceMappingURL=api-def.js.map